import React from 'react';
import {Typography, makeStyles} from '@material-ui/core';

import type {CRMCustomer} from '../../../../../../../entities';
import {useStoreCurrency} from '../../../../../currency/utils';
import {colors} from '../../../../../../assets/styles/colors';
import {commaFormat} from '../../../../../../utils/number';

const useStyles = makeStyles(theme => ({
  subtitle: {
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 500,
  },
  greyText: {
    color: colors.grey700,
    fontSize: 14,
    fontWeight: 400,
  },
  section: {
    padding: theme.spacing(0, 1),
  },
  row: {
    margin: theme.spacing(1, 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

type Props = {
  crmCustomer: CRMCustomer,
};

export default function SellInfo(props: Props) {
  const currency = useStoreCurrency();
  const {crmCustomer} = props;

  const classes = useStyles();

  return (
    <div className={classes.section}>
      <Typography className={classes.subtitle}>Datos de compra</Typography>
      <div className={classes.sellInfo}>
        {crmCustomer.crmCustomerCategory && (
          <div className={classes.row}>
            <Typography className={classes.greyText}>Categoría</Typography>
            <Typography className={classes.subtitle}>
              {crmCustomer.crmCustomerCategory}
            </Typography>
          </div>
        )}
        <div className={classes.row}>
          <Typography className={classes.greyText}>Ticket Promedio</Typography>
          <Typography className={classes.subtitle}>
            {commaFormat(
              crmCustomer.averageOrderAmount,
              currency ? currency.symbol : ''
            )}
          </Typography>
        </div>
        <div className={classes.row}>
          <Typography className={classes.greyText}>Compras totales</Typography>
          <Typography className={classes.subtitle}>
            {commaFormat(
              crmCustomer.totalOrderAmount,
              currency ? currency.symbol : ''
            )}
          </Typography>
        </div>
        <div className={classes.row}>
          <Typography className={classes.greyText}>Ordenes hechas</Typography>
          <Typography className={classes.subtitle}>
            {crmCustomer.numberOfOrders}
          </Typography>
        </div>
      </div>
    </div>
  );
}
